import { useEffect } from 'react'
import { isNullUndefined } from '../../../common/Helpers';
import { getLogroLimites } from '../../../services/sKPI/board.service';

const useSetInicialValues = (chartConfig, setChartConfig) => {    
    useEffect(()=> {
        const doIt = async () => {
            try {
                await getLogroLimites().then((response) => {   
                    setChartConfig(response.data.data)
                }).catch((e) => {
                    setChartConfig({
                        logroMaximo: null,
                        logroMinimo: null,
                        maxKPI: null,
                        minKPI: null
                    })
                });
            }
            catch (error) {
                setChartConfig({
                    logroMaximo: null,
                    logroMinimo: null,
                    maxKPI: null,
                    minKPI: null
                })
            }
        }

        if (isNullUndefined(chartConfig)) {        
            doIt()
        }
    }, [chartConfig, setChartConfig]);
}

export {
    useSetInicialValues
}